











































































































import Vue from 'vue'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import { LegacyUrlService } from '~/services/legacy/url/LegacyUrlService'
import { mapGetters } from 'vuex'
import { APP_NS } from '~/store/modules/shared/app/state'

export default Vue.extend({
  model: {
    prop: 'show',
    event: 'input'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(APP_NS, {
      domain: 'domain'
    }),
    icons() {
      return {
        check: faCheck
      }
    },
    accountCreationLink() {
      return this.$dep(LegacyUrlService).getRegisterUrl()
    },
    visible: {
      get() {
        return this.show
      },
      set(value: boolean) {
        this.$emit('input', value)
        this.$emit('change', value)
      }
    }
  }
})
